import { FC } from 'react'

import { Dialog } from '@syconium/little-miss-figgy/dist/components'

import { gql } from '../../../../../../__generated__/graphql/catalog/gql'
import { SizeChartFragmentFragment } from '../../../../../../__generated__/graphql/catalog/graphql'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { SizeChartModalContent } from '../../../../../../brunswick/components/size-chart/SizeChartModal/SizeChartModalContent'
import { trackEvent } from '../../../../../../lib/analytics'

import * as Styles from './styles'

export const sizeChartFields = gql(`
  fragment SizeChartFragment on SizeChartCG {
      __typename
      id
      columnNames
      columnValues
      imageUri
      name
      navLabel
      tables {
          cells
          measureImage
          measureTips {
              kind
              tip
          }
          sizeTips {
              kind
              tip
          }
          subtitle
          tabLabel
          title
      }
      tips {
          kind
          tip
      }
      title
      video
  }
`)

export type SizeChartTip = NonNullable<SizeChartFragmentFragment['tips']>[number]

export type SizeChartTableCells = ReadonlyArray<ReadonlyArray<string>>

export type SizeChartTable = NonNullable<SizeChartFragmentFragment['tables']>[number]

export type SizeChart = SizeChartFragmentFragment

interface Props {
  category?: string
  sizeChart: SizeChart | undefined
  hideTitle?: boolean
  className?: string
}

export const SizeChart: FC<Props> = ({ category, sizeChart, className }) => {
  const {
    sizesSection: { sizeChartCTA, sizeChart: sizeChartText },
  } = useTranslation()

  return (
    <Dialog.Provider>
      <Dialog.Disclosure
        render={
          <Styles.SizeChartButton
            aria-label={sizeChartCTA}
            className={className}
            {...trackEvent({
              category: category ?? sizeChart?.name ?? 'Size Chart',
              action: 'open size chart',
            })}
          >
            {sizeChartCTA}
          </Styles.SizeChartButton>
        }
      />
      <Styles.DialogModal
        header={
          <Dialog.Header
            title={<Styles.ModalHeader>{sizeChartText.modalHeadline}</Styles.ModalHeader>}
            dismiss={<Dialog.Dismiss aria-label='Close modal' />}
          />
        }
        footer={null}
        fullscreenMobile
        content={<Styles.ModalContent />}
      >
        <SizeChartModalContent sizeChart={sizeChart} showHeader={false} />
      </Styles.DialogModal>
    </Dialog.Provider>
  )
}
